const DATA_FILE_TYPES = ['csv', 'txt'];

export default function isDataFile(file) {
	let name = file.name.toLowerCase();

	return DATA_FILE_TYPES.filter((type) => {
		return name.indexOf('.' + type) !== -1;
	}).length > 0;
}